module.exports = __webpack_public_path__ + "img/CoinTracking_square.7d106aa.png";